// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"d8eb17b7","297":"f65be896","614":"64250497"}[chunkId] + ".chunk.css";
};